import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Typography
} from "@material-ui/core";
import MapPin from "../../../../../components/MapPin";
import GoogleMapReact from "google-map-react";
import React, {FC} from "react";
import styled from "styled-components/macro";
import {Delete as DeleteIcon, ExpandMore as ExpandMoreIcon} from "@material-ui/icons";
import {useTranslation} from "react-i18next";
import {IconButton} from "@mui/material";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";

const GoogleMapReactWrapper = styled.div`
  height: 300px;
  width: 100%;
  position: relative;
`;

const MapPinWrapper = styled.div`
  position: absolute;
  height: 100px;
  width: 100px;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
`

const getMapOptions = (maps: GoogleMapReact.Maps) => {
  return {
    fullscreenControl: true,
    mapTypeControl: true,
    mapTypeId: maps.MapTypeId.ROADMAP,
    scaleControl: true,
    scrollwheel: false,
    streetViewControl: true,
  };
}

const MAP_KEY = 'AIzaSyD5R0bYPps6EYg2B4d1VFoZJ3lJrVlZX-s'

type PropsType = {
  addPoint: boolean,
  onSetAddPoint: (value: boolean) => void
  coordinates: number[]
  onDragEnd: (value: any) => void
  isExistPoint: boolean
  onDeletePoint: () => void
}

const UnitMap: FC<PropsType> = ({
  addPoint,
  onSetAddPoint,
  coordinates,
  onDragEnd,
  isExistPoint,
  onDeletePoint
}) => {
  const {t} = useTranslation()

  const handleDeletePoint = (e: any) => {
    e.stopPropagation()
    Swal.fire({
      title: t('imagesPage_Are_your_sure'),
      text: `Delete point on map?`,
      confirmButtonText: t('imagesPage_Yes'),
      cancelButtonText: t('imagesPage_Cancel'),
      showCancelButton: true,
      reverseButtons: true,
      width: '400px'
    }).then((result) => {
      if (result.isConfirmed) {
        onDeletePoint()
      }
    })
  }

  return (
    <React.Fragment>
      <Accordion
        style={{border: '1px solid rgba(255, 255, 255, 0.12)'}}
        expanded={addPoint}
        onChange={() => onSetAddPoint(!addPoint)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant={'h6'}>{t('add_point_on_map')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box display={'flex'} flexDirection={'column'} width={'100%'}>
            <GoogleMapReactWrapper>
              <MapPinWrapper>
                <MapPin
                  lng={coordinates[0]}
                  lat={coordinates[1]}
                />
              </MapPinWrapper>
              <GoogleMapReact
                options={getMapOptions}
                bootstrapURLKeys={{ key: MAP_KEY }}
                onDragEnd={onDragEnd}
                center={{ lng: coordinates[0], lat: coordinates[1] }}
                defaultZoom={14}
              />
            </GoogleMapReactWrapper>
            {isExistPoint ? (
              <Box mt={2} display={'flex'} justifyContent={'right'}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDeletePoint}
                  placeholder={'Delete point'}
                  aria-label="Delete"
                  size={'small'}
                  endIcon={<DeleteIcon />}
                >
                  <Typography style={{fontWeight: 500}}>{t('imagesPage_Delete')}</Typography>
                </Button>
              </Box>
            ) : null}
          </Box>
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  )
}

export default UnitMap